import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, CardBody, CardFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { requestPasswordRecoveryMethod } from '../../services/fetcher';
import Message from '../../components/Message';
import HtmlParser from 'react-html-parser';
import LoadingSpinner from '../../components/LoadingSpinner';
import { useRecoverPassword } from '../../hooks/useRecoverPassword';

const RecoverPassword = () => {
    const [loginData, setLoginData] = useState({});
    const [responseData, setResponseData] = useState({});
    const [t] = useTranslation('app');
    const logo = process.env.REACT_APP_IMAGE_BAR;

    const { loading, requestPasswordChange } = useRecoverPassword()

    const handleChange = ({ target: { value, name } }) => {
        setLoginData((prev) => {
            return {
                ...prev,
                [name]: value
            };
        });
    };

    const requestChange = async (e) => {
        setResponseData({});
        requestPasswordChange(loginData.username).then((res) => {
            setResponseData({
                "token_for_recovery": res.token_for_recovery,
                "message": res.message,
                "color": res.token_for_recovery ? "success" : "error"
            })
        }).catch((e) => {
            setResponseData({
                message: t('saveError'),
                color: 'error'
            })
        })
    }

    return (
        <CardBody className="Login-content">
            <img className="Login-logo" src={logo} alt="logo" />
            {responseData?.message && <Message type={responseData.color} >{HtmlParser(responseData.message)}</Message>}
            {!responseData?.token_for_recovery && <>
                <input
                    className="Login-input"
                    type="text"
                    placeholder={t('login.user')}
                    name="username"
                    onChange={handleChange}
                />
                <Button className="Login-btn" type="button" onClick={requestChange}>
                    {loading && <LoadingSpinner show />}
                    {!loading && t('login.password_recovery.request_change')}
                </Button>
            </>}
        </CardBody>
    )
}

RecoverPassword.propTypes = {}

export default RecoverPassword